import { Button, Modal, Spin } from 'antd';
import React from 'react';
import PrescriptionsLandingPage from '../PrescriptionsLandingPage';
import s from './s.module.less';
import commonS from 'styles/common.module.less';
import PracticeStateConfig from 'components/PracticeStateConfig';
import ScriptSureOnboarding from './components/ScriptSureOnboarding';
import usePracticeStateList from 'hooks/usePracticeStateList';

type Props = {
    onFinish?: () => void;
};

const PrescriptionsRegisterPage = (props: Props) => {
    const { onFinish } = props;
    const [showTips, setShowTips] = React.useState<boolean>(true);
    const [showLearnMore, setShowLearnMore] = React.useState<boolean>(false);
    const [showStateSetUp, setShowStateSetUp] = React.useState<boolean>(true);
    const [serverPracticeStateList, serverPracticeStateListLoading, fetchServerPracticeStateList] = usePracticeStateList();

    React.useEffect(() => {
        if (serverPracticeStateList && serverPracticeStateList.length > 0) {
            setShowStateSetUp(false);
        }
    }, [serverPracticeStateList]);

    return (
        <div
            className={s.wrap}
            style={{
                background: showStateSetUp ? '#F9FAFC' : '#f3f4f6',
            }}
        >
            <div className={s.header}>
                <span>Prescriptions</span>
                <Button
                    onClick={() => {
                        setShowLearnMore(true);
                    }}
                    className={s.btn}
                    size="large"
                >Learn more
                </Button>
            </div>
            <div className={s.des}>
                Send prescriptions seamlessly with Klarity E-Prescriptions powered by ScriptSure.
            </div>
            {
                showTips && (
                    <div className={s.tips}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM13.7071 8.70711C14.0976 8.31658 14.0976 7.68342 13.7071 7.29289C13.3166 6.90237 12.6834 6.90237 12.2929 7.29289L9 10.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L8.29289 12.7071C8.68342 13.0976 9.31658 13.0976 9.70711 12.7071L13.7071 8.70711Z" fill="#34D399" />
                        </svg>
                        <div className={s.text}>
                            Congratulations! 🎉 You’ve successfully subscribed to Klarity E-Prescriptions. Create your ScriptSure account now to start sending prescriptions to pharmacies securely.
                        </div>
                        <span
                            onClick={() => {
                                setShowTips(false);
                            }}
                            className={s.close}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M4.29289 4.29289C4.68342 3.90237 5.31658 3.90237 5.70711 4.29289L10 8.58579L14.2929 4.29289C14.6834 3.90237 15.3166 3.90237 15.7071 4.29289C16.0976 4.68342 16.0976 5.31658 15.7071 5.70711L11.4142 10L15.7071 14.2929C16.0976 14.6834 16.0976 15.3166 15.7071 15.7071C15.3166 16.0976 14.6834 16.0976 14.2929 15.7071L10 11.4142L5.70711 15.7071C5.31658 16.0976 4.68342 16.0976 4.29289 15.7071C3.90237 15.3166 3.90237 14.6834 4.29289 14.2929L8.58579 10L4.29289 5.70711C3.90237 5.31658 3.90237 4.68342 4.29289 4.29289Z" fill="#10B981" />
                            </svg>
                        </span>
                    </div>
                )
            }
            {
                serverPracticeStateListLoading && (
                    <Spin />
                )
            }
            {
                showStateSetUp && !serverPracticeStateListLoading && (
                    <PracticeStateConfig
                        onFinish={() => {
                            setShowStateSetUp(false);
                        }}
                    />
                )
            }
            {
                !showStateSetUp && (
                    <ScriptSureOnboarding
                        onFinish={onFinish}
                    />
                )
            }
            <Modal
                open={showLearnMore}
                onCancel={() => setShowLearnMore(false)}
                footer={null}
                width="84%"
                className={commonS.modalFixHeightWithoutPaddingWrap}
                title="Learn more about Klarity E-Prescriptions"
            >
                <PrescriptionsLandingPage isModal />
            </Modal>
        </div>
    );
};

export default PrescriptionsRegisterPage;
